import React from 'react';
import { Reveal } from './Reveal';
import { transformationStats } from '../data/transformation';
export function TransformationSection() {
  return <section aria-labelledby="transformation-title" className="bg-brand-ivory px-4 py-20 md:py-28" data-id="element-280" data-mp="31xicmqebhih6">
      <Reveal className="mx-auto max-w-6xl" data-id="element-281" data-mp="2wzqirqu43mac">
        <div className="mx-auto max-w-3xl text-center" data-id="element-282" data-mp="2rz2kql7gu56m">
          <p className="mb-4 text-xs font-extrabold uppercase tracking-[0.18em] text-brand-teal-ink" data-id="element-283" data-mp="2s0nbs0ukn5zq">
            VOTRE PRÉPARATION, PLUS CLAIRE
          </p>
          <h2 id="transformation-title" className="text-3xl font-extrabold leading-tight tracking-tight text-brand-navy md:text-5xl md:leading-[1.08]" data-id="element-284" data-mp="2j57lftt0z8yw">
            Des idées dispersées à un <span className="italic text-brand-teal" data-id="element-285" data-mp="299mgbmsntskx">parcours musical organisé.</span>
          </h2>
          <p className="mx-auto mt-5 max-w-2xl text-sm leading-relaxed text-slate-600 md:text-base" data-id="element-286" data-mp="248gmfln9jz9t">
            Écouter, interpréter, créer et faire le point&nbsp;: des ressources pour articuler les apprentissages au
            fil de vos séances.
          </p>
        </div>
        <div className="mx-auto mt-12 grid max-w-3xl gap-4 md:grid-cols-3" data-id="element-287" data-mp="k2ucloj6sd7h">
          {transformationStats.map(({
          value,
          label
        }) => <div key={value} className="rounded-2xl border border-brand-line bg-white px-5 py-7 text-center shadow-sm" data-id="element-288" data-mp="5epo23xgd7gs">
              <strong className="block text-3xl font-extrabold leading-none text-brand-teal" data-id="element-289" data-mp="y1ka359x4ewd">{value}</strong>
              <span className="mt-3 block text-xs font-semibold leading-snug text-slate-600" data-id="element-290" data-mp="130eqk0kexrdb">{label}</span>
            </div>)}
        </div>
      </Reveal>
    </section>;
}